import { useMutation, useQueryClient } from "@tanstack/react-query";
import { retakeCourse } from "../../../core/queries/course";

export function useRetakeCourse() {
    const queryClient = useQueryClient();

    const {
        data,
        isError,
        error,
        isSuccess,
        isPending,
        mutate
    } = useMutation({
            mutationKey: ['course-drop'],
            mutationFn: (slug: string) => retakeCourse(slug),
            retry: false,
            onSuccess: () => {
                queryClient.removeQueries({ queryKey: ['myCourses'] });
            }
        });

    return {
        data,
        isError,
        isLoadingRetake: isPending,
        error,
        isSuccess,
        mutateRetake: mutate,
    };
}
